import authorized from "@/middleware/authorized"
import paid from '@/middleware/paid'

export default {
    path: '/reports', name: "ReportsGeneral",
    meta: { middleware: [authorized, paid], layout: "default", rights: ['reports_tab'] },
    component: () => import('../components/pages/reports/ReportsGeneral.vue'),
    children: [
        // { path: '', redirect: 'cash_flows' },
        {
            path: 'day', name: "ReportDay",
            meta: { middleware: [authorized, paid], layout: "default", rights: ['reports_tab', 'reports_day'] },
            component: () => import('../components/pages/reports/ReportDay.vue')
        },
        {
            path: 'pl', name: "ReportsPL",
            meta: { middleware: [authorized, paid], layout: "default", rights: ['reports_tab', 'reports_pnl'] },
            component: () => import('../components/pages/reports/ReportsPL.vue')
        },
        {
            path: 'cash_flows', name: "ReportsCashFlows",
            meta: { middleware: [authorized, paid], layout: "default", rights: ['reports_tab', 'reports_cash'] },
            component: () => import('../components/pages/reports/ReportsCashFlows.vue')
        },
        {
            path: 'cashdesk', name: "ReportCashdesk",
            meta: { middleware: [authorized, paid], layout: "default", rights: ['reports_cashdesk'] },
            component: () => import('../components/pages/reports/ReportCashdesk.vue')
        },
        {
            path: 'debtors', name: "ReportsDebtors",
            meta: { middleware: [authorized, paid], layout: "default", rights: ['reports_tab', 'reports_debtors'] },
            component: () => import('../components/pages/reports/ReportsDebtors.vue')
        },
        {
            path: 'visits', name: "ReportsVisits",
            meta: { middleware: [authorized, paid], layout: "default", rights: ['reports_tab', 'reports_visits'] },
            component: () => import('../components/pages/reports/ReportsVisits.vue')
        },
        {
            path: 'visits_detailed', name: "ReportsVisitsDetailed",
            meta: { middleware: [authorized, paid], layout: "default", rights: ['reports_tab', 'reports_visits'] },
            component: () => import('../components/pages/reports/ReportsVisitsDetailed.vue')
        },
        {
            path: 'cancelled_visits', name: "ReportsCancelledVisits",
            meta: { middleware: [authorized, paid], layout: "default", rights: ['reports_tab', 'reports_cancelled'] },
            component: () => import('../components/pages/reports/ReportsCancelledVisits.vue')
        },
        {
            path: 'patients', name: "ReportsPatients",
            meta: { middleware: [authorized, paid], layout: "default", rights: ['reports_tab', 'reports_patients'] },
            component: () => import('../components/pages/reports/ReportsPatients.vue')
        },
        {
            path: 'diagnoses', name: "ReportsDiagnoses",
            meta: { middleware: [authorized, paid], layout: "default", rights: ['reports_tab', 'reports_diagnoses'] },
            component: () => import('../components/pages/reports/ReportsDiagnoses.vue')
        },
        {
            path: 'salaries', name: "ReportsSalaries",
            meta: { middleware: [authorized, paid], layout: "default", rights: ['reports_tab', 'reports_salaries'] },
            component: () => import('../components/pages/reports/ReportsSalaries.vue')
        },
        {
            path: 'income_by_doctors', name: "ReportsIncomeByDoctors",
            meta: { middleware: [authorized, paid], layout: "default", rights: ['reports_tab', 'reports_doctors_revenues'] },
            component: () => import('../components/pages/reports/ReportsIncomeByDoctors.vue')
        },
        {
            path: 'income_by_services', name: "ReportsIncomeByServices",
            meta: { middleware: [authorized, paid], layout: "default", rights: ['reports_tab', 'reports_services_revenues'] },
            component: () => import('../components/pages/reports/ReportsIncomeByServices.vue')
        },
        {
            path: 'materials', name: "ReportsMaterials",
            meta: { middleware: [authorized, paid], layout: "default", rights: ['reports_tab', 'reports_materials'] },
            component: () => import('../components/pages/reports/ReportsMaterials.vue')
        },
        {
            path: 'materials_movement_analytics', name: "ReportsMaterialsMovement",
            meta: { middleware: [authorized, paid], layout: "default", rights: ['reports_tab', 'reports_materials_movement_analytics'] },
            component: () => import('../components/pages/reports/ReportsMaterialsMovement.vue')
        },
        {
            path: 'services', name: "ReportsServices",
            meta: { middleware: [authorized, paid], layout: "default", rights: ['reports_tab', 'reports_services'] },
            component: () => import('../components/pages/reports/ReportsServices.vue')
        },
        {
            path: 'f57', name: "Report57",
            meta: { middleware: [authorized, paid], layout: "default", rights: ['reports_tab', 'reports_57'] },
            component: () => import('../components/pages/reports/Report57.vue')
        },
        {
            path: 'stat_visits', name: "ReportStatVisits",
            meta: { middleware: [authorized, paid], layout: "default", rights: ['reports_tab', 'reports_stat_visits'] },
            component: () => import('../components/pages/reports/ReportStatVisits.vue')
        },
        {
            path: 'stat_admins', name: "ReportStatAdmins",
            meta: { middleware: [authorized, paid], layout: "default", rights: ['reports_tab', 'reports_stat_admins'] },
            component: () => import('../components/pages/reports/ReportStatAdmins.vue')
        },
        {
            path: 'stat_doctors', name: "ReportStatDoctors",
            meta: { middleware: [authorized, paid], layout: "default", rights: ['reports_tab', 'reports_stat_doctors'] },
            component: () => import('../components/pages/reports/ReportStatDoctors.vue')
        },
        {
            path: 'doctors_load', name: "ReportDoctorsLoad",
            meta: { middleware: [authorized, paid], layout: "default", rights: ['reports_tab', 'reports_doctors_load'] },
            component: () => import('../components/pages/reports/ReportDoctorsLoad.vue')
        },
        {
            path: 'guarantee', name: "ReportGuarantee",
            meta: { middleware: [authorized, paid], layout: "default", rights: ['reports_tab', 'reports_warranty_case'] },
            component: () => import('../components/pages/reports/ReportGuarantee.vue')
        },
        {
            path: 'crm_analytics', name: "ReportCRMAnalytics",
            meta: { middleware: [authorized, paid], layout: "default", rights: ['reports_tab', 'reports_crm_analytics'] },
            component: () => import('../components/pages/reports/ReportCRMAnalytics.vue')
        },
        {
            path: 'visits_by_source', name: "ReportVisitSourceAnalytics",
            meta: { middleware: [authorized, paid], layout: "default", rights: ['reports_tab', 'reports_visit_source'] },
            component: () => import('../components/pages/reports/ReportVisitSourceAnalytics.vue')
        },
        {
            path: 'doctors_conversion', name: "ReportDoctorsConversion",
            meta: { middleware: [authorized, paid], layout: "default", rights: ['reports_tab', 'reports_doctors_conversion'] },
            component: () => import('../components/pages/reports/ReportDoctorsConversion.vue')
        },
        {
            path: 'insurance', name: "ReportInsurance",
            meta: { middleware: [authorized, paid], layout: "default", rights: ['reports_tab', 'report_insurance'] },
            component:() => import('../components/pages/reports/ReportInsurance.vue')
        },
        {
            path: 'bonuses', name: "ReportBonuses",
            meta: { middleware: [authorized, paid], layout: "default", rights: ['reports_tab', 'report_bonuses'] },
            component:() => import('../components/pages/reports/ReportBonuses.vue')
        },
        {
            path: 'deleted_payments', name: "ReportDeletedPayments",
            meta: { middleware: [authorized, paid], layout: "default", rights: ['reports_tab', 'report_deleted_payments'] },
            component:() => import('../components/pages/reports/ReportDeletedPayments.vue')
        },
        {
            path: 'patients_conversion', name: "ReportPatientsConversion",
            meta: { middleware: [authorized, paid], layout: "default", rights: ['reports_tab', 'reports_patients_conversion'] },
            component:() => import('../components/pages/reports/ReportPatientsConversion.vue')
        },
        {
            path: 'sale_of_goods', name: "ReportSaleOfGoods",
            meta: { middleware: [authorized, paid], layout: "default", rights: ['reports_tab', 'cashregister_sell_goods'] },
            component:() => import('../components/pages/reports/ReportSaleOfGoods.vue')
        },
        {
            path: 'deposit_movements', name: "ReportDepositMovements",
            meta: { middleware: [authorized, paid], layout: "default", rights: ['reports_tab', 'report_deposit_movements'] },
            component:() => import('../components/pages/reports/ReportDepositMovements.vue')
        },
        {
            path: 'patient_deposits', name: "ReportDepositBalances",
            meta: { middleware: [authorized, paid], layout: "default", rights: ['reports_tab', 'report_deposit_balances'] },
            component:() => import('../components/pages/reports/ReportDepositBalances.vue')
        },
    ]
}
